import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Whether API access is enabled for this entity.
 */
export const schema = z.boolean();

export type ApiEnabled = z.infer<typeof schema>;

export const definition = define({
  key: 'api_enabled',
  schema,
  label: 'API Enabled',
  description:
    'Activate/Deactivate the API feature for clients at this level. Currently, this is only a visual indicator of the client to show that they use the API. In the future, this switch may behave differently.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.INTEGRATIONS.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: false,
});
